export default function isObject(obj) {
  return (obj+"") === "[object Object]"
}
